/**
 * Tickets resource — support tickets raised from a conversation (or standalone).
 *
 * Thin typed wrappers over {@link endpoints.tickets} (`/api/v1/tickets`).
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { Ticket, TicketInput, TicketPriority, TicketStatus } from '../../types';

/** Query params for listing tickets. */
export interface ListTicketsParams {
  status?: string;
  /** Filter to tickets raised from this conversation. */
  sessionId?: string;
  limit?: number;
  offset?: number;
}

/** PATCH body for updating a ticket (all fields optional). */
export interface TicketPatch {
  status?: TicketStatus;
  priority?: TicketPriority;
  subject?: string;
  description?: string;
}

export class TicketsResource {
  constructor(private readonly http: HttpClient) {}

  list(params: ListTicketsParams = {}): Promise<{ items: Ticket[] }> {
    return this.http.get(endpoints.tickets.list(), { query: { ...params } });
  }

  create(input: TicketInput): Promise<Ticket> {
    return this.http.post(endpoints.tickets.create(), input);
  }

  get(id: string): Promise<Ticket> {
    return this.http.get(endpoints.tickets.detail(id));
  }

  update(id: string, patch: TicketPatch): Promise<Ticket> {
    return this.http.patch(endpoints.tickets.detail(id), patch);
  }
}
